// extracted by mini-css-extract-plugin
export var box = "_4a-1";
export var checkboxRow = "_4a-8";
export var checked = "_4a-2";
export var descriptionSpacer = "_4a-a";
export var disabled = "_4a-3";
export var icon = "_4a-6";
export var input = "_4a-0";
export var labelSpacer = "_4a-9";
export var medium = "_4a-5";
export var small = "_4a-4";
export var text = "_4a-7";